import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Welcome", testId: "nav-welcome-link" },
  { to: "/about", label: "About", testId: "nav-about-link" },
  { to: "/books", label: "Books", testId: "nav-books-link" },
  { to: "/game", label: "Game", testId: "nav-game-link" },
  { to: "/playlist", label: "Playlist", testId: "nav-playlist-link" },
  { to: "/contact", label: "Contact", testId: "nav-contact-link" },
];

const linkClass = ({ isActive }) =>
  `nav-link text-sm tracking-[0.2em] uppercase transition-colors duration-300 hover:text-cocoa ${isActive ? "active text-cocoa" : "text-cocoa/60"}`;

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed inset-x-0 top-0 z-40 border-b border-cocoa/10 bg-background/85 backdrop-blur-xl" data-testid="site-header">
      <nav className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 md:px-8">
        <Link to="/" data-testid="nav-logo-link" className="font-display text-2xl italic tracking-tight" onClick={() => setOpen(false)}>
          Morgan Ella
        </Link>
        <div className="hidden items-center gap-9 md:flex">
          {links.map((link) => <NavLink key={link.to} to={link.to} data-testid={link.testId} className={linkClass}>{link.label}</NavLink>)}
        </div>
        <Link to="/books" data-testid="nav-browse-button" className="hidden rounded-full bg-cocoa px-6 py-3 text-sm text-background transition-transform duration-300 hover:scale-105 md:block">
          Browse the shelf
        </Link>
        <button type="button" data-testid="mobile-menu-button" aria-label="Toggle navigation menu" onClick={() => setOpen(!open)} className="text-cocoa md:hidden">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>
      {open && (
        <div className="border-t border-cocoa/10 bg-background px-5 py-6 md:hidden" data-testid="mobile-menu-panel">
          <div className="flex flex-col gap-5">
            {links.map((link) => <NavLink key={link.to} to={link.to} data-testid={`mobile-${link.testId}`} className={linkClass} onClick={() => setOpen(false)}>{link.label}</NavLink>)}
          </div>
        </div>
      )}
    </header>
  );
}
